const COLORS = {
    // BRICK_ENDPOINT_INCOMING_HOVER: '#CCC', //#33B587

    BRICK_ENDPOINT_INCOMING: '#CCC', //#4E7668
    BRICK_ENDPOINT_OUTGOING: '#CCC', //#AECAD7
    
    BRICK_ENDPOINT_OUTFLOW: '#656565',
    
    BRICK_CONNECTION_ENABLED: '#CCC', //#BDB6B8
    BRICK_CONNECTION_DISABLED: '#FA4646' //#CCC
}

const FLAGS = {
    //Hidden as per request in DNX-793
    hideContentSettings: true,
    
    //https://datanext.atlassian.net/browse/DPN-2788
    //https://datanext.atlassian.net/browse/DPN-2783
    //Not used anymore; component is fairly large, disable it for the time being
    //removal can take place at a later stage
    hideActionConditionsSettings: true,
    
    //Temporarily disabled as per request in DPN-2911, enable in a later phase
    //https://datanext.atlassian.net/browse/DPN-2911?focusedCommentId=54452
    enableTogglingFilterExclusionGroups: false,
    
    //Disabled as per request in DPN-2904
    displayGoalToggleForTouchpointBricks: false,

    //Temporarily disabled as per request in DPN-3111, enable in a later phase
    //https://datanext.atlassian.net/browse/DPN-3111
    displayABFilterBrickInMenu: false
}

export {
    COLORS,
    FLAGS
}